<template lang="pug" src="./addresses.pug"></template>

<script>
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import validate from '@/mixins/validate';
import { demical } from '@/utils/helpers';

import config from '../../../../config.json';

function generateFiels(prop) {
    return ['uk', 'ru', 'en'].map(locale => `${prop}:${locale}`);
}

function genetateAddressData() {
    return Object.assign({
        houseNumber: null,
        latitude: null,
        longitude: null
    },
        ...generateFiels('street').map(it => ({ [it]: null })),
        ...generateFiels('name').map(it => ({ [it]: null })),
        ...generateFiels('city').map(it => ({
            [it]: config.serverCityName[it.split(':')[1]]
        })),
    );
}

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        filters: {
            street: null,
            name: null
        },
        modal: false,
        address: genetateAddressData(),
        disableSaveBtn: false,
        requestProcessing: false
    }),
    validations: {
        address: {
            houseNumber: {
                required
            },
            ...Object.assign({}, ...generateFiels('street').map(it => ({
                [it]: {
                    required
                }
            }))),
           ...Object.assign({}, ...generateFiels('name').map(it => ({
                [it]: {
                    required: function(val) {
                        if (val) return true;
                        return !generateFiels('name').some(it => !!this.address[it]);
                    }
                }
            }))),
            ...Object.assign({}, ...generateFiels('city').map(it => ({
                [it]: {
                    required
                }
            }))),
            latitude: {
                required,
                demical
            },
            longitude: {
                required,
                demical
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.addresses.items,
            pagination: state => state.addresses.pagination
        }),
        headers() {
            return [
                ...generateFiels('street'),
                ...generateFiels('name'),
                'houseNumber',
                ...generateFiels('city'),
                'latitude', 'longitude', 'action'
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Addresses.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    watch: {
        address: {
            handler: function(val) {
                if (val && val.longitude) {
                    val.longitude = val.longitude.replace(',', '.');
                }

                if (val && val.latitude) {
                    val.latitude = val.latitude.replace(',', '.');
                }
            },
            deep: true
        }
    },
    created() {
        this.loadItems();
    },
    methods: {
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('addresses/getItems', Object.assign({}, this.filters, {
                page
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },

        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        },

        showCreateModal() {
            this.modal = true;
        },

        cancel() {
            this.modal = false;
            this.address = genetateAddressData();
            this.disableSaveBtn = false;

            this.$v.address.$reset();
        },

        async create() {
            if (this.$v.address.$invalid) {
                return this.$v.address.$touch();
            }

            this.disableSaveBtn = true;

            await this.$store.dispatch('addresses/create', { ...this.address });
            await this.loadItems(this.pagination.page);

            this.cancel();
        },

        async destroy(id) {
            await this.$store.dispatch('addresses/destroy', id);
            await this.loadItems(this.pagination.page);
        }
    }
};
</script>
